
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NSwitch from '@/uikit/switch/NSwitch.vue';
import { CameraGroup } from '@/api';
import NForm, { IFormContext, IFormModel } from '@/uikit/forms/NForm.vue';
import { NConfidence, NInputNumber } from '@/uikit';
import { getNumberValidator } from '@/uikit/forms/validators';
import { settingsItemModule } from '@/store/data/SettingsItemModule';
import { isDefined } from '@/definitions/services/helpers';

@Options({
  name: 'ExtendedEventAnalysisExtraSettings',
  components: { NForm, NSwitch }
})
export default class ExtendedEventAnalysisExtraSettings extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: CameraGroup;

  showExtraSettings = false;

  get extraSettings() {
    return this.item.extended_event_analysis;
  }

  get layout() {
    return [
      {
        path: 'extended_event_analysis.min_quality',
        i18n_label: 'common.extended_analysis_quality_threshold',
        classes: 'label-m n-form-w-4 n-form-label-horizontal-200 n-form-pad-10',
        component: NInputNumber,
        props: function(this: IFormContext, model: IFormModel) {
          return { min: 0, max: 1, step: 0.01 };
        },
        validators: [getNumberValidator({ required: false, min: 0, max: 1, float: true })],
      },
      {
        path: 'extended_event_analysis.lookup_threshold',
        classes: 'label-m n-form-w-2 n-form-label-horizontal-200 n-form-pad-10',
        i18n_label: 'common.extended_analysis_comparison_threshold',
        component: NConfidence,
        props: { controls: true }
      }
    ];
  }

  @Watch('showExtraSettings')
  setShowExtraSettings(v: boolean) {
    this.extraSettings!.min_quality = v ? this.extraSettings!.min_quality : null;
    this.extraSettings!.lookup_threshold = v ? this.extraSettings!.lookup_threshold ?? settingsItemModule.item!.face_confidence_threshold : null;
  }

  created() {
    this.showExtraSettings = isDefined(this.extraSettings?.min_quality) || isDefined(this.extraSettings?.lookup_threshold);
  }
}
